class CallvarientSelect extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onSelectInputChange);
    }
    
    onSelectInputChange() {
      this.updateOptions();
      this.updateMasterId();
      
      if (this.currentVariant) {
        this.updateVariantInput();
      }
  
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    getVariantData() {
      try {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      } catch (error) {
        console.log(error)
      }
      
      return this.variantData;
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-call-card-${this.dataset.productId}`);
      
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        let priceDiv = document.getElementById(`pcws-price-${this.dataset.productId}`);
        
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          priceDiv.innerHTML = `<span><s class="price-item price-item--regular">$ ${(this.compare_at_price.price / 100).toFixed(2)} USD</s></span><span class="price-item price-item--regular">$${this.currentVariant.price / 100} USD</span>`
        } else {
          priceDiv.innerHTML = `<span class="price-item price-item--regular">$${(this.currentVariant.price / 100).toFixed(2)} USD</span>`
        }
        

        input.dispatchEvent(new Event('change', { bubbles: false }));
      })
    }
  
}
  
customElements.define('callvarient-select', CallvarientSelect);
  
if (!customElements.get('colcproduct-form')) {
    customElements.define('colcproduct-form', class ColcproductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector('cart-notification');
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            const submitButton = this.querySelector('[type="submit"]');
            if (submitButton.classList.contains('btnloading')) return; 

            // cart notificaiton 
            this.cartNotification.setActiveElement(document.activeElement);

            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('btnloading');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            });

            
            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                if (response.status) {
                    console.log(response.status)
                    this.handleErrorMessage(response.description);
                    return;
                }

                this.cartNotification.renderContents(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                         

//         if(typeof WSAIO.cartDrawer === "undefined"){
//               var cartdrawerr=false;
//               var _intv = setInterval(function(){
//                 if($('.cart-notification').hasClass('active') && cartdrawerr==false){
//                   cartdrawerr=true;
//                   //================== replce checkout button =============================
//                   setTimeout(function(){
// //                     console.log('changeaaaa11112222')
//                     WSAIO.preCheckout();
//                   },400)
//                 }
//                 else if(!$('.cart-notification').hasClass('active') && cartdrawerr==true){
//                   cartdrawerr=false;
//                 }
//               },200);
//             }
                         
                         
                    console.log('successfully done')
                    submitButton.classList.remove('btnloading');
                    submitButton.removeAttribute('aria-disabled');
                });



        }
    })
}